<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Select Completed Date
    </div>
    <div>
        <mat-icon
            mat-dialog-close
            [svgIcon]="'heroicons_solid:x-mark'"
        ></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <form [formGroup]="form" class="w-full">
        <mat-form-field class="w-full">
            <input
                matInput
                [matDatepicker]="startPicker"
                formControlName="completedDate"
                [max]="today"
                class="w-full"
            />
            <mat-datepicker-toggle
                matIconSuffix
                [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-1" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary mx-1" (click)="closeDialog()">Save</button>
</mat-dialog-actions>
